var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8794 26.192C23.2262 27.3826 22.2622 28.3467 21.0714 40C19.8808 28.3468 18.9167 27.3828 7.26341 26.192C18.9166 25.0014 19.8806 24.0373 21.0714 12.384C22.2621 24.0372 23.2261 25.0028 34.8794 26.192ZM27.0654 0C26.2513 7.9828 25.5904 8.6436 17.6074 9.458C25.5902 10.2736 26.251 10.9346 27.0654 18.916C27.8811 10.9332 28.542 10.2724 36.5234 9.458C28.5422 8.64392 27.8814 7.983 27.0654 0ZM11.1574 6.4248C10.4949 12.9092 9.95897 13.4468 3.47461 14.1076C9.95901 14.7701 10.4966 15.306 11.1574 21.7904C11.8199 15.306 12.3558 14.7684 18.8418 14.1076C12.3574 13.4467 11.8198 12.9092 11.1574 6.4248Z",
    fill: "#2A2D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.6c14db48923fd00d3d02c3489cd4e9b1.svg";
export { ForwardRef as ReactComponent };